<template>
	<div class="com-box-content" style="padding:0 5px;box-sizing: border-box;">
		<div class="itemBox" :style="'width:100%;height:'+height+'px;margin-left:'+marleft+'px;margin-right:'+marRight+'px'">
            <div class="titleBox">
                <div class="flex align-end justify-center" style="padding-top:13px; padding-bottom:7px;line-height: 1;">
                	
                	<div class="text-center base-font-17 text-white text-bold" style="">{{title}}</div>
                	<div class="enTitle" v-if="enTitle">
                		<div class="line"></div>
                		<div>{{enTitle}}</div>
                	</div>
                </div>
            </div>
			
			<slot name="content"></slot>
		</div>
	</div>
</template>
<script>
	export default{
		props: {
		    width: {
		      default: '100%'
		    },
		    height: {
		      default: 306
		    },
		    minHeight: {
		      default: '0px'
		    },
            marleft:{
                default: '0px'
            },
            marRight:{
                default: '0px'
            },
		    title: {
		      default: ''
		    },
			enTitle: {
			  default:null
			},
		  },
		data(){
			return{
				boxObj:{
					height:'306px',
					title:"访问来源Top10"
				}
			}
		}
	}
</script>

<style lang="scss">
	.com-box-content{
		.itemBox{position:relative;}
        .base-font-17{font-size: 17px;}
		.lt{width:43px;height:41px;background:url('../../assets/images/xsd/tltop.png') top center no-repeat;position:absolute;top:0;left:0;}
		.tr{width:43px;height:41px;background:url('../../assets/images/xsd/trtop.png') top center no-repeat;position:absolute;top:0;right:0;}
		.rb{width:43px;height:41px;background:url('../../assets/images/xsd/rbtop.png') top center no-repeat;position:absolute;bottom:0;right:0;}
		.lb{width:43px;height:41px;background:url('../../assets/images/xsd/lbtop.png') top center no-repeat;position:absolute;left:0;bottom:0;}
		.enTitle{margin-left:5px;}
        .titleBox{
            width:100%;height:53px;padding-top:14px;box-sizing: border-box;
           background:url('../../assets/img/titlebg.png') top center no-repeat;background-size: 260px;height:53px; 
        }
	}
	
</style>